import React from "react";
import SubscriptionChangedBanner from "src/components/promotion/banners/SubscriptionChangedBanner";
import Layout from "src/components/layout/Layout";
import CurrentMandate from "src/components/subscription/billing/CurrentMandate";
import CurrentSubscription from "src/components/subscription/billing/CurrentSubscription";
import CurrentWallet from "src/components/subscription/billing/CurrentWallet";
import SubscriptionNextPayment from "src/components/subscription/billing/SubscriptionNextPayment";
import SubscriptionPaymentsTable from "src/components/subscription/billing/SubscriptionPaymentsTable";
import useAuth from "src/hooks/selectors/useAuth";
import NoSubscriptionMiddleware from "src/components/middlewares/NoSubscriptionMiddleware";
import { useTranslation } from "react-i18next";
import ProfileTabs from "src/views/authenticated/profile/ProfileTabs";

export default function BillingView() {
	const { t } = useTranslation("payment-view", { keyPrefix: "billing-view" });

	const auth = useAuth();
	const subscription = auth?.company?.subscription || {};

	if (!subscription?.name) {
		return <NoSubscriptionMiddleware tabs={<ProfileTabs />} />;
	}

	return (
		<Layout className="dashboard-profile" title={t("title")}>
			<ProfileTabs />
			<div className="md:grid flex flex-col md:grid-cols-3 gap-8">
				{subscription?.next_plan && <SubscriptionChangedBanner />}
				<CurrentSubscription {...{ subscription }} />
				<div className="flex flex-col gap-8">
					<SubscriptionNextPayment {...{ subscription }} />
					<CurrentMandate />
				</div>
				<CurrentWallet />

				<div className="col-span-3 mt-8">
					<h2 className="mb-8">{t("payment-history.title")}</h2>
					<SubscriptionPaymentsTable />
				</div>
			</div>
		</Layout>
	);
}
